import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://www.taskicabs.com/adminbackend/vendor'
    // baseURL: 'http://192.168.29.55:2020/adminbackend/vendor',
})

const token = localStorage.getItem('vendorToken');
if(token) {
    instance.defaults.headers.common['token'] = token
}
export default instance